import { useQuery } from "@tanstack/react-query";
import { useAPIClient } from "render/context/APIContext";
import { applySignal } from "./applySignal";

export function useBloodWorkModeQuery(pointer: {
  patientId: string;
  visitId: string;
}) {
  const api = useAPIClient();
  return useQuery({
    queryKey: ["bloodWorkMode", pointer.patientId, pointer.visitId],
    queryFn: ({ signal }) => {
      const req = api.bloodSample.getBloodWorkModeFor(pointer);
      applySignal(req, signal);

      return req.result;
    },
  });
}
